<template>
	<div class="white">
		<v-container v-if="record" class="pb-0">
			<v-row justify="center">
				<v-col v-if="$vuetify.breakpoint.mdAndUp" cols="4">
					<app-ad middle></app-ad>
				</v-col>

				<v-col cols="12" md="8">
					<v-row class="text-center">
						<v-col cols="12" class="text-start">
							<h3>{{ record.specialties }}</h3>
							<span v-if="configViewCount" class="pe-2">
								<v-icon right>mdi-eye</v-icon>
								{{ record.viewCount }}
							</span>
							<span>
								<v-icon right>mdi-calendar</v-icon>
								{{ record.published_date }}
							</span>
						</v-col>

						<v-col v-if="!$vuetify.breakpoint.mdAndUp" cols="12">
							<app-ad middle></app-ad>
						</v-col>

						<v-col cols="12">
							<v-row class="text-start">
								<v-col cols="12">
									<span>{{ record.description }}</span>
								</v-col>
								<v-col cols="12" class="text-h6 font-weight-bold">تفاصيل الطلب</v-col>
								<v-col cols="12">
									<b>التخصص الأساسي:</b>&nbsp;
									<span>{{ record.specialtiesName }}</span>
								</v-col>
								<v-col v-if="record.otherSpecialtiesIDs" cols="12">
									<b>تخصصات البديل الأخرى:</b>&nbsp;
									<span>{{ record.otherSpecialtiesIDs.map(s => s.name).join(" , ") }}</span>
								</v-col>
								<v-col cols="12">
									<v-divider></v-divider>
								</v-col>
								<v-col cols="12">
									<b>يبحث عن:</b>&nbsp;
									<span>{{ record.gender }}</span>
								</v-col>
								<v-col cols="12">
									<b>نوع التوظيف:</b>&nbsp;
									<span>{{ record.transferType }}</span>
								</v-col>

								<v-col v-if="(record.section && record.section != 'null') || record.requiredSections" cols="12">
									<v-divider></v-divider>
								</v-col>

								<v-col v-if="record.section && record.section != 'null'" cols="12">
									<b>القسم الحالي:</b>&nbsp;
									<span>{{ record.section }}</span>
								</v-col>
								<v-col v-if="record.requiredSections" cols="12">
									<b>الأقسام المرغوب الإنتقال إليها:</b>&nbsp;
									<span v-if="record.requiredSections">{{ record.requiredSections.join(" , ") }}</span>
								</v-col>

								<v-col cols="12">
									<v-divider></v-divider>
								</v-col>

								<v-col v-if="record.citiesPerRegion.length" cols="12">
									<b>المناطق والمدن المراد الإنتقال إليها:</b>
									<br />
									<v-row
										v-for="region in record.citiesPerRegion"
										:key="region.regionName"
										dense
										class="pt-2"
									>
										<v-col cols="12">{{ region.regionName }}</v-col>
										<template v-for="city in region.cities">
											<v-col v-if="city.hospitals.length == 0" :key="city.name" cols="6" md="4" lg="3" xl="2">
												<v-card class="pa-1" outlined>
													<v-card-title class="text-body-1 pb-1 pt-2 word-break">
														{{ city.name }}
														<v-spacer></v-spacer>
														<v-btn text icon @click="openSubmissionDialog('city', city.name, city.id)">
															<v-icon>mdi-map-marker</v-icon>
														</v-btn>
													</v-card-title>
												</v-card>
											</v-col>
											<template v-else>
												<v-col v-for="hospital in city.hospitals" :key="hospital.id" cols="6" md="4" lg="3" xl="2">
													<v-card class="pa-1" outlined>
														<v-card-title class="text-body-1 pb-1 pt-2 word-break">
															{{ city.name }} - {{ hospital.name }}
															<v-spacer></v-spacer>
															<v-btn
																text
																icon
																@click="openSubmissionDialog('hospital', city.name +' - '+ hospital.name, hospital.id
																)"
															>
																<v-icon>mdi-map-marker</v-icon>
															</v-btn>
														</v-card-title>
													</v-card>
												</v-col>
											</template>
										</template>
									</v-row>
								</v-col>

								<v-col v-if="record.note" cols="12">
									<b>ملاحظات اضافية:</b>
									<br />
									<pre>{{ record.note }}</pre>
								</v-col>

								<v-col v-if="record.communications.length" cols="12">
									<b>بيانات التواصل:</b>
									
									<v-row dense class="pt-2 pb-4">
										<v-col cols="12">
											<v-divider></v-divider>
										</v-col>
									</v-row>
									
									<app-communication-list :communications="record.communications"></app-communication-list>
								</v-col>
							</v-row>
						</v-col>

						<v-col cols="12">
							<v-alert v-if="isOwner" type="info">
								انت صاحب الطلب
							</v-alert>

							<v-alert v-else-if="record.reciveRequests == false" type="error">
								الطلب مغلق
							</v-alert>

							<v-btn
								v-else
								color="primary"
								outlined
								:disabled="record.reciveRequests != 1"
								@click="openSubmissionDialog"
							>
								إرسال الطلب
							</v-btn>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-container>

		<v-dialog v-model="showSubmissionDialog" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>إرسال الطلب</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid1">
						<v-row no-gutters>
							<v-col v-if="showCitySubmission || showHospitalSubmission " cols="12" class="pa-2">
								<div>{{ submissionLabel }}</div>
							</v-col>
							<v-col
								v-if="showCitySubmission == false && showHospitalSubmission == false"
								cols="12"
								class="pa-2"
							>
								<v-select
									v-model="newRecord.country"
									outlined
									hide-details="auto"
									label="الدولة"
									:items="countries"
									item-text="name"
									item-value="countryID"
									:rules="[rules.required]"
									disabled
								></v-select>
							</v-col>
							<v-col
								v-if="showCitySubmission == false && showHospitalSubmission == false"
								cols="12"
								class="pa-2"
							>
								<v-select
									v-model="newRecord.region"
									outlined
									hide-details="auto"
									label="المنطقة"
									:items="regions"
									item-text="name"
									item-value="regionID"
									:rules="[rules.required]"
								></v-select>
							</v-col>
							<v-col
								v-if="showCitySubmission == false && showHospitalSubmission == false"
								cols="12"
								class="pa-2"
							>
								<v-select
									v-model="newRecord.city"
									outlined
									hide-details="auto"
									label="المدينة"
									:items="cities"
									item-text="name"
									item-value="cityID"
									:rules="[rules.required]"
								></v-select>
							</v-col>
							<v-col v-if="showHospitalSubmission == false" cols="12" class="pa-2">
								<v-select
									v-model="newRecord.place"
									outlined
									hide-details="auto"
									label="المستشفى"
									:items="places"
									item-text="name"
									item-value="id"
									:rules="[rules.required]"
								>
									<template v-if="newRecord.city" #prepend-item>
										<v-list-item @click="showAddNewHospital = true">
											<v-list-item-title>إضافة مستشفى جديد</v-list-item-title>
											<v-list-item-action>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-action>
										</v-list-item>
									</template>
								</v-select>
							</v-col>
							<v-col cols="12" class="text-center pt-2" @mouseover=";">
								<v-btn color="primary" :disabled="!valid1" :loading="loading" @click="submitRequest">إرسال</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="showAddNewHospital" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>إضافة مستشفى جديد</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form ref="addCompanyForm" v-model="valid2">
						<v-row dense>
							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="newHospital.name"
									outlined
									label="اسم المستشفى"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="text-center" @mouseover=";">
								<v-btn color="primary" :disabled="!valid2" :loading="loading" @click="addNewHospital">إضافة</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<app-social-sharing
			v-if="record"
			:id="$route.params.recordID"
			type="replacement"
			:content="{ /*url: record.url,*/ title: record.description/*, description: record.note*/ }"
			:style="$vuetify.breakpoint.mdAndUp ? '' : 'margin-bottom: calc(90/728 * 100vw);'"
		></app-social-sharing>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import clientNotifier from "@/clientNotifier";

export default {
	components: {
		"app-ad": require("@/components/general/AppAd").default,
		"app-communication-list": () => import(/* webpackChunkName: "app-communication-list" */ "@/components/content/AppCommunicationList"),
		"app-social-sharing": require("@/components/general/AppSocialSharing")
			.default
	},
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			tab: 1,
			record: null,
			infoHeaders: [
				{ text: "المدينة", value: "cityName" },
				{ text: "المكان", value: "placeName" },
				{ text: "وصف المكان", value: "locationDetails" },
				{ text: "تاريخ البدء", value: "startDate" },
				{ text: "تاريخ الإنتهاء", value: "endDate" },
				{ text: "وقت البدء", value: "startTime" },
				{ text: "وقت الانتهاء", value: "endTime" },
				{ text: "الوصف", value: "description" }
			],

			galleryHeaders: [
				{ text: "الاسم", value: "name" },
				{ text: "الوصف", value: "description" },
				{ text: "تحميل", value: "download" }
			],
			showSubmissionDialog: false,
			showAddNewHospital: false,
			newRecord: {
				country: null,
				region: null,
				city: null,
				place: null
			},
			countries: [],
			regions: [],
			cities: [],
			places: [],
			newHospital: {
				name: null
			},
			valid1: false,
			valid2: false,
			loading: false,
			showCitySubmission: false,
			showHospitalSubmission: false,
			submissionLabel: null
		};
	},
	computed: {
		configViewCount() {
			return this.$store.state.viewCount;
		},
		isOwner() {
			return this.$store.state.profile?.id == this.record?.userID;
		}
	},
	watch: {
		"newRecord.country"(newVal) {
			this.newRecord.region = null;
			this.regions = [];
			this.getRegions(newVal);
		},
		"newRecord.region"(newVal) {
			this.newRecord.city = null;
			this.cities = [];
			this.getCities(newVal);
		},
		"newRecord.city"(newVal) {
			this.newRecord.place = null;
			this.places = [];
			this.getPlaces(newVal);
		}
	},
	mounted() {
		this.getRecord();
		// this.getCountries();
		this.countries = [
			{
				countryID: "sa",
				name: "المملكة العربية السعودية"
			}
		];
		this.newRecord.country = 'sa';
	},
	methods: {
		getCountries() {
			client
				.get("/api/location/countries")
				.then(response => {
					this.countries = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getRegions(countryID) {
			client
				.post("/api/location/countryregions", { countryID: countryID })
				.then(response => {
					this.regions = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCities(regionID) {
			client
				.post("/api/location/regioncities", { regionID: regionID })
				.then(response => {
					this.cities = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getPlaces(cityID) {
			client
				.post("/api/location/hospitals", { cityID: cityID })
				.then(response => {
					this.places = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getRecord() {
			client
				.get(
					"/api/replacements/show/" + this.$route.params.recordID,
					{}
				)
				.then(response => {
					console.log(response);
					var newData = response.data.data[0];

					var citiesPerRegion = [];
					var regions = [];
					newData.toCities.forEach(city => {
						var index = regions.indexOf(city.regionName);
						if (index == -1) {
							regions.push(city.regionName);
							citiesPerRegion.push({
								regionName: city.regionName,
								cities: [
									{
										id: city.cityID,
										name: city.cityName,
										hospitals: city.hospitals || []
									}
								]
							});
						} else {
							citiesPerRegion[index].cities.push({
								id: city.cityID,
								name: city.cityName,
								hospitals: city.hospitals || []
							});
						}
					});
					newData.citiesPerRegion = citiesPerRegion;

					if (newData.maleReplacement && newData.femaleReplacement) {
						newData.gender = "بديل أو بديلة";
					} else if (newData.maleReplacement) {
						newData.gender = "بديل";
					} else if (newData.femaleReplacement) {
						newData.gender = "بديلة";
					}

					if (newData.note == "null") {
						newData.note = null;
					}

					if (newData.section == "null") {
						newData.section = null;
					}

					this.record = newData;
				})
				.catch(err => {
					console.log(err);
					this.$store.dispatch("notify", {
						message: err.response.data.message,
						color: "error"
					});
				});
		},
		addNewHospital() {
			this.loading = true;
			var data = {
				...this.newHospital,
				// isHospital: 1,
				cityID: this.newRecord.city
			};
			client
				.post("/api/location/addhospital", data)
				.then(response => {
					this.$store.dispatch("notify", {
						message: "تم الحفظ"
					});
					this.places.push({
						name: this.newHospital.name,
						id: response.data.data.id
					});
					this.newRecord.place = response.data.data.id;
					this.showAddNewHospital = false;
					this.newHospital = {
						name: null
					};
					setTimeout(() => {
						this.valid2 = true;
					}, 0);
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		submitRequest() {
			this.loading = true;
			var data = {
				replacementID: this.$route.params.recordID,
				placeID: this.newRecord.place
			};
			clientNotifier
				.post("/api/replacements/replacmentoffer", data)
				.then(response => {
					this.showSubmissionDialog = false;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		openSubmissionDialog(type, label, place) {
			if (this.isOwner) {
				return;
			}
			if (this.record.reciveRequests != 1) {
				return;
			}

			this.showHospitalSubmission = false;
			this.showCitySubmission = false;
			this.submissionLabel = null;

			if (type == "hospital") {
				this.showHospitalSubmission = true;
				this.submissionLabel = "من: " + label;
				this.newRecord.place = place;
			} else if (type == "city") {
				this.showCitySubmission = true;
				this.submissionLabel = "من مدينة: " + label;
				this.newRecord.city = place;
			}

			this.showSubmissionDialog = true;
		}
	}
};
</script>